"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral")),
    _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _templateObject() {
  var a = (0, _taggedTemplateLiteral2["default"])(["\n  mutation DeleteAssetMutation($assetId: String!) {\n    deleteAsset(assetId: $assetId) {\n      assetId\n    }\n  }\n"]);
  return _templateObject = function _templateObject() {
    return a;
  }, a;
}

var deleteAssetMutation = (0, _graphqlTag["default"])(_templateObject()),
    _default = function _default() {
  return {
    mutation: deleteAssetMutation,
    module: "assets",
    buildVariables: function buildVariables(a) {
      return {
        assetId: a
      };
    }
  };
};

exports["default"] = _default;